import { useDispatch, useSelector } from "react-redux";
import { AXNUIFormHelpTextContainer } from "@iddataweb/idw-common-ui/containers";
import { getConfigurationLayout, getGeneralTheme } from "@redux/selectors/verification-configuration-selectors";
import { getLanguageContent } from "@redux/selectors/language-selectors";
import { getExplicitConsentChecked } from "@redux/selectors/verification-form-selectors";
import { setExplicitConsentChecked } from "@redux/actions/verification-form-actions";
import { useMemo } from "react";
import { getAXNUILayoutHelpTextParameters } from "@iddataweb/idw-common-ui/utils";
import { ThemingGenericContentSlotTypes } from "@iddataweb/idw-common-ui/enums";

type PostFormHelpTextContainerProps = {
    isSubmitting: boolean;
};

export const PostFormHelpTextContainer = (props: PostFormHelpTextContainerProps) => {
    const dispatch = useDispatch();

    const {
        isSubmitting
    } = props;

    const content = useSelector(getLanguageContent);
    const theme = useSelector(getGeneralTheme);
    const layout = useSelector(getConfigurationLayout);
    const explicitConsentChecked = useSelector(getExplicitConsentChecked);

    const setExplicitConsentCheckedInternal = () => {
        dispatch(setExplicitConsentChecked(!explicitConsentChecked));
    };

    const helpTextParameters = useMemo(() => {
        if(layout?.helpText?.postFormHelpText){
            return getAXNUILayoutHelpTextParameters(content, layout, ThemingGenericContentSlotTypes.POST_FORM_HELP_TEXT);
        }
    
        return null;
    }, [layout, content]);

    const elementLength = layout?.helpText?.postFormHelpText?.order?.length || 0;
    if (elementLength === 0) {
        return null;
    }

    return (
        <>
            {elementLength > 0 && (
                <AXNUIFormHelpTextContainer
                    parameters={helpTextParameters}
                    id={"postFormHelpText"}
                    isSubmitting={isSubmitting}
                    textColor={theme?.mainTextColor}
                    fontFamily={theme?.font}
                    buttonTextColor={theme?.mainButtonTextColor}
                    buttonBackgroundColor={theme?.mainButtonBackgroundColor}
                    linksColor={theme?.linksColor}
                    content={content}
                    explicitConsentChecked={explicitConsentChecked}
                    setExplicitConsentChecked={setExplicitConsentCheckedInternal}
                />
            )}
        </>
    );
};